import { ConfigurationIcon } from '@genially/icons';

import { GameControlButton } from '../../../../../../../../../../shared/application/components/GameControlButton/GameControlButton';
import { useHostGameContext } from '../../../../HostGame.context';

export const SettingsGameControlButton = () => {
  const { settingsSidebar } = useHostGameContext();

  const handleClick = () => {
    settingsSidebar.toggle();
  };

  return <GameControlButton Icon={ConfigurationIcon} onClick={handleClick} />;
};
